const shifts = {
  toast: {
    error: {
      badResponse: '[Rate] resposta inválida do servidor',
    },
  },

  create: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível Criar Turno',
    },
    successToast: {
      message: 'sucesso! Turno criado com sucesso',
    },
  },

  delete: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível excluir o turno',
    },
    successToast: {
      message: 'sucesso! turnos excluídos com sucesso.',
    },
    confirmation: {
      header: 'Confirmação de exclusão de turnos',
      body: {
        dynamic: 'Você está prestes a excluir {{numShifts}} turnos.',
        all: 'Você está prestes a excluir todos os turnos.',
      },
    },
  },

  edit: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar o turno',
    },
    successToast: {
      message: 'sucesso! Turno atualizado com sucesso',
    },
  },

  headerButtons: {
    create: 'Criar',
  },

  table: {
    headers: {
      name: 'Nome',
      status: 'Status',
      start: 'Início',
      end: 'Fim',
      year: 'Ano',
      direction: 'Direção',
      weekDays: 'Dias da semana',
    },
    cells: {
      weekDays: {
        weekDaysOptions: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      },
      status: {
        statusOptions: {
          statusActive: 'Ativo',
          statusNotActive: 'Não ativo',
        },
      },
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  form: {
    header: {
      createShift: {
        title: 'Criar',
      },

      updateShift: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Turno',
        fields: {
          name: 'Nome',
          status: 'Status',
          start: 'Início',
          end: 'Fim',
          year: 'Ano',
          direction: 'Direção',
          weekDays: 'Dias da Semana',
        },
      },
      directionOptions: {
        selectDirection: 'Selecione a Direção',
        from: 'Recolher',
        to: 'Distribuir',
        both: 'Coletar & Distribuir',
      },
    },
    validations: {
      name: {
        required: 'Campo de nomeação obrigatória',
        name: '',
      },
      start: {
        required: 'O início é requerido',
        start: '',
      },
      end: {
        required: 'O fim é requerido',
        end: '',
      },
      year: {
        required: 'O ano é obrigatório',
        year: '',
      },
      direction: {
        required: 'Direção é obrigatória',
        direction: '',
      },
      weekDays: {
        required: 'Você deve selecionar pelo menos um dia',
        weekDays: '',
      },
    },
    notification: {
      overnight: 'O horário de término é anterior ao horário de início, o que significa que a coleta será no dia seguinte',
    },
    
  },
};

export default shifts;
